import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { WriteDoor } from './rostersAdminTabs';

type WriteSurfaces = Readonly<{
  /** The dialog standing open, or null where none is. */
  openDoor: WriteDoor | null;
  rosterId: number | null;
  /** The cohort the open door is aimed at; null for a roster line. */
  pinnedCohortId: number | null;
}>;

export const useAgentContext = ({ openDoor, rosterId, pinnedCohortId }: WriteSurfaces) => {
  useRegisterAgentContext(
    openDoor === 'createCohort'
      ? {
          kind: 'form',
          description: 'The create-cohort dialog on the rosters admin page.',
          data: { roster_id: rosterId, fields: ['roster', 'name', 'code', 'coaches'] },
        }
      : null,
  );

  useRegisterAgentContext(
    openDoor === 'mint'
      ? {
          kind: 'form',
          description:
            'The create-code dialog on the rosters admin page. The code is typed by the operator or generated, and is six letters or numbers.',
          data: { roster_id: rosterId, pinned_cohort_id: pinnedCohortId, fields: ['code'] },
        }
      : null,
  );

  useRegisterAgentContext(
    openDoor === 'revoke'
      ? {
          kind: 'form',
          description: 'The revoke-code dialog on the rosters admin page.',
          data: { roster_id: rosterId, pinned_cohort_id: pinnedCohortId },
        }
      : null,
  );

  useRegisterAgentContext(
    openDoor === 'manageCoaches'
      ? {
          kind: 'form',
          description: 'The add/remove coaches dialog for a cohort on the rosters admin page.',
          data: { roster_id: rosterId, pinned_cohort_id: pinnedCohortId },
        }
      : null,
  );

  useRegisterAgentContext(
    openDoor === 'manageMembers'
      ? {
          kind: 'form',
          description:
            "The manage-users picker for a cohort on the rosters admin page. It lists the cohort's members, and switches to the people seated on its roster who are not in it.",
          data: { roster_id: rosterId, pinned_cohort_id: pinnedCohortId },
        }
      : null,
  );

  useRegisterAgentContext(
    openDoor === 'renameCohort'
      ? {
          kind: 'form',
          description: 'The rename-cohort dialog on the rosters admin page.',
          data: { roster_id: rosterId, pinned_cohort_id: pinnedCohortId, fields: ['name'] },
        }
      : null,
  );
};
